import React from "react";
import { Box, Button, Stack, Tooltip, Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "react-i18next";

import { ArmeniaAct } from "./ArmeniaActsHistoryDrawer";

type Props = {
  acts: ArmeniaAct[];
  onOpen: () => void;
};

const ArmeniaActsCell = ({ acts, onOpen }: Props) => {
  const { t } = useTranslation();

  if (!acts.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t("armeniaAct.cell.noAct")}
      </Typography>
    );
  }

  const hasDisputes = acts.some((act) => act.status === "DISAGREEMENT");

  return (
    <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Button
          size="small"
          variant="outlined"
          startIcon={<DescriptionIcon />}
          onClick={(e) => {
            e.stopPropagation();
            onOpen();
          }}
          sx={{ minWidth: 0, px: 1 }}
        >
          {t("armeniaAct.cell.acts", { count: acts.length })}
        </Button>

        {hasDisputes && (
          <Tooltip title={t("armeniaAct.cell.hasDisputes")}>
            <WarningAmberIcon color="warning" fontSize="small" />
          </Tooltip>
        )}
      </Stack>
    </Box>
  );
};

export default ArmeniaActsCell;
